const cacheData = {};
const keysToPersist = {};

function isInvalidKey(key) {
  return typeof key === 'undefined' ||
    typeof key === 'object' ||
    typeof key === 'boolean';
}

// function isInvalidValue(value) {
//   return value === null ||
//     typeof value === 'undefined';
// }

export function keys() {
  return Object.getOwnPropertyNames(cacheData);
}

export function get(key) {
  if(isInvalidKey(key)) {
    return null;
  }
  return cacheData[key];
}

export function save(key, value, isPersist) {
  if(
    isInvalidKey(key)
    // value不用限制要存什么
    // isInvalidValue(value)
  ) {
    throw new Error('Invalid key or value');
  }
  if(isPersist) {
    keysToPersist[key] = true;
  }
  cacheData[key] = value;
}

export function remove(key) {
  if(
    isInvalidKey(key) ||
    keysToPersist[key]
  ) {
    return;
  }
  delete cacheData[key];
}

export function clear() {
  for (const key in cacheData) {
    remove(key);
  }
}
